import { MysqlApi } from 'src/orchd-client';

import { axiosInstance } from 'src/utils/axios';

export const mysqlApi = MysqlApi({}, '/api', axiosInstance);
